import { FC } from "react";
import { MenuItem } from "./MenuItems/MenuItem";
import { menuAdminItems, MenuItemType, MenuProps } from "./MenuItems/menuItems";
import { Restricted } from "../Restricted";
import { BORDER_STYLES } from "../../ui/layout/detailedPages/styles";

export const MenuAdmin: FC<React.PropsWithChildren<MenuProps>> = ({
  closeMenuMobile,
}) => {
  return (
    <Restricted requiredPagesPermission="users">
      <nav className={`mt-2 space-y-1 border-t px-2 py-2 ${BORDER_STYLES}`}>
        {menuAdminItems.map((item: MenuItemType) => (
          <MenuItem
            item={item}
            key={item.name}
            closeMenuMobile={closeMenuMobile}
          />
        ))}
      </nav>
    </Restricted>
  );
};
